var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useMemo, useRef, useState, } from 'react';
import { useLocation } from 'react-router-dom';
import { ModalContext } from '../ModalContext';
export const ModalProvider = ({ children, }) => {
    _react_refresh_temp_2();
    const [openedModals, setOpenedModals] = useState([]);
    const { hash, pathname, search } = useLocation();
    // Lets `isModalOpen` read the latest modals while the context value stays memoized.
    const openedModalsRef = useRef(openedModals);
    openedModalsRef.current = openedModals;
    const previousLocationRef = useRef({ hash, pathname, search });
    useEffect(() => {
        const previousLocation = previousLocationRef.current;
        previousLocationRef.current = { hash, pathname, search };
        const hasLocationChanged = previousLocation.pathname !== pathname ||
            previousLocation.search !== search ||
            previousLocation.hash !== hash;
        if (!hasLocationChanged) {
            return;
        }
        setOpenedModals((currentOpenedModals) => currentOpenedModals.filter((openedModal) => !openedModal.closeOnNavigate));
    }, [hash, pathname, search]);
    const modalContextValue = useMemo(() => {
        return {
            closeAllModals: () => setOpenedModals([]),
            closeModal: (modalId) => setOpenedModals((currentOpenedModals) => currentOpenedModals.filter((currentModal) => currentModal.modalId !== modalId)),
            isModalOpen: (modalId) => openedModalsRef.current.some((openedModal) => openedModal.modalId === modalId),
            openModal: ({ closeOnNavigate, content, modalId }) => setOpenedModals((currentOpenedModals) => {
                if (!currentOpenedModals.find((currentModal) => currentModal.modalId === modalId)) {
                    return [
                        ...currentOpenedModals,
                        { closeOnNavigate, content, modalId },
                    ];
                }
                else {
                    return currentOpenedModals;
                }
            }),
            updateModal: ({ closeOnNavigate, content, modalId, newModalId, }) => setOpenedModals((currentOpenedModals) => {
                const modalIndex = currentOpenedModals.findIndex((currentModal) => currentModal.modalId === modalId);
                if (modalId === newModalId) {
                    // eslint-disable-next-line no-console -- notify
                    console.error(`Provided newModalId and current modalId are the same: ${modalId}. Modal will not be updated.`);
                    return currentOpenedModals;
                }
                if (modalIndex > -1) {
                    const updatedOpenedModals = [...currentOpenedModals];
                    if (newModalId) {
                        const isNewModalIdTaken = updatedOpenedModals.findIndex(({ modalId }) => modalId === newModalId) > -1;
                        if (isNewModalIdTaken) {
                            // eslint-disable-next-line no-console -- notify that modalId is already taken and will not be updated
                            console.error(`Provided newModalId is already present: ${modalId}. Modal will not be updated.`);
                            return currentOpenedModals;
                        }
                    }
                    updatedOpenedModals[modalIndex] = {
                        closeOnNavigate,
                        content,
                        modalId: newModalId ?? modalId,
                    };
                    return updatedOpenedModals;
                }
                else {
                    return currentOpenedModals;
                }
            }),
        };
    }, []);
    return (_jsxs(ModalContext.Provider, { value: modalContextValue, children: [openedModals.map(({ content, modalId }) => (_jsx(Fragment, { children: content }, modalId))), children] }));
};
_react_refresh_temp_1 = ModalProvider;
$RefreshReg$(_react_refresh_temp_1, "ModalProvider");
_react_refresh_temp_2(ModalProvider, "ZDmlSicI1LWFameOkeHGX2V3/h8=", false, () => [useLocation]);
